module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("em2My"))).then(() => module.bundle.root('d0iPb'));